import React from "react";

const CreateStatus = () => {
  return (
    <div>
      <h1>create Status</h1>
    </div>
  );
};

export default CreateStatus;
